module.exports = __webpack_public_path__ + "img/[抠鼻].9f53e950.svg";